import React, { ReactNode } from 'react'
import isMobile from 'ismobilejs'

type Props = {
  children: ReactNode | Element
}

export const HideOnMobileDevice = ({ children }: Props) => {
  const { phone } = isMobile()

  if (!phone) {
    return <>{children}</>
  }

  return null
}
